<div>
    <app-nav class="_sticky _top-0 _z-50 _block _border-b _shadow-bottom"></app-nav>
    <div class="_flex _flex-row _items-start _justify-center sm-max:_w-full _mx-auto">
        <div class="md:_container _mx-auto _w-full _py-2 _px-4 md:_px-2">
            <div class="_flex _flex-col">
                <div *ngIf="wishlist" class="_flex _flex-col xs:_flex-row _justify-between _w-full _my-4 sm:_my-8">
                    <div class="_flex _flex-col sm:_flex-row _items-start sm:_items-center sm-max:_mb-4">
                        <div class="_flex _items-center sm-max:_mb-4"> 
                            <button class="_button-reset _flex-grow-0 _pl-0"
                                [routerLink]="['/wishlists']"
                                data-tab-button-no-events>
                                <i class="fa-sharp fa-light fa-chevrons-left"></i>
                            </button>
                            <h1 class="_text-h3-m md:_text-h2">
                                Edit {{ "wishlist" | businessName }}:
                            </h1>
                        </div>
                        <div class="_flex _items-center sm:_ml-4">   
                            <span class="_text-h4-m">{{ wishlist.name }}</span>
                            <span class="_cursor-pointer _ml-4" matTooltip="Edit the name of this proposal">
                                <i class="fa-light fa-pen-to-square" (click)="updateWishlist()"></i>
                            </span>  
                            <span *ngIf="!isEmpty" class="_cursor-pointer _ml-4" matTooltip="Preview this proposal">
                                <i class="fa-sharp fa-light fa-eye" (click)="previewWishlist()"></i>
                            </span> 
                        </div>
                    </div>
                    <div *ngIf="!isEmpty" class="_flex _flex-row xs:_flex-col sm:_flex-row _gap-2">
                        <button 
                            *ngIf="wishlist.status == WishlistStatus.Active" 
                            class="_button-secondary" 
                            (click)="copyLink()">
                                <i class="fa-light fa-copy _mr-1"></i>
                                Copy share link
                        </button>
                        <button 
                            *ngIf="wishlist.status == WishlistStatus.Active" 
                            class="_button-secondary" 
                            (click)="emailLink()">
                                <i class="fa-light fa-envelope _mr-1"></i>
                                Email share link
                        </button>
                    </div>
                </div>
                
                <div *ngIf="isEmpty; else tableTemplate">
                    <app-empty-state-screen intoBoxMessage="You haven not added any listings to this proposal.">
                        <div class="_flex _items-center _space-x-2 _cursor-pointer _mt-4">
                            <button class="_button-primary _m-auto" (click)="startWorkOnThisList()">
                                Begin your search
                            </button>
                        </div>
                    </app-empty-state-screen>
                </div>

                <ng-template #tableTemplate>
                    <app-overflow-container 
                    [useArrows]="[false, false]"
                    [useGradients]="[false, true]">
                        <div class="_w-full">
                            <table mat-table matSort sortingCache [dataSource]="dataSource" *ngIf="dataSource" class="_min-w-max _w-full">
                                <ng-container matColumnDef="photo">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let wish">
                                        <img class="_py-2 xs-max:_w-20" app-imagekit [source]="coverImageUrl(wish)" transform="tr:w-128,h-72">
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef> 
                                        <span class="_py-2 _px-4">Name</span>
                                    </th>
                                    <td mat-cell *matCellDef="let wish"> 
                                        <div class="_py-2 _px-4">
                                            <div class="_font-bold">{{ listingName(wish) }}</div>
                                            <div>{{ listingSuite(wish)}}</div>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="location">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef> 
                                        <span class="_py-2 _px-4">Location</span>
                                    </th>
                                    <td mat-cell *matCellDef="let wish"> 
                                        <div class="_py-2 _px-4">
                                            <div>{{ listingCity(wish) }},</div>
                                            <div>
                                                <app-country-code [countryCode]="listingCountry(wish)"></app-country-code>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="price">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef> 
                                        <span class="_py-2 _px-4">Price</span>
                                    </th>
                                    <td mat-cell *matCellDef="let wish">
                                        <div class="_py-2 _px-4" *ngIf="!wish.searchListing.fees">
                                            <div>from</div>
                                            <div class="_font-bold">
                                                <app-booking-price [fees]="wish.searchListing.priceRange.lowest"></app-booking-price>
                                            </div>
                                            <div>per night</div>
                                        </div>
                                        <div class="_py-2 _px-4" *ngIf="wish.searchListing.fees">
                                            <div class="_font-bold">
                                                <app-booking-price [fees]="wish.searchListing.fees"></app-booking-price>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="brand">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                        <span class="_py-2 _px-4">Brand</span>
                                    </th>
                                    <td mat-cell *matCellDef="let wish"> 
                                        <div class="_py-2 _px-4">
                                            {{ brand(wish) }}
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="dates">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef>
                                        <span class="_py-2 _px-4">Travel Dates</span>
                                    </th>
                                    <td mat-cell *matCellDef="let wish">
                                        <div class="_py-2 _px-4" *ngIf="wish.travelDates">
                                            <div>{{ wish.travelDates.checkin | date:'dd MMM YY' }} 
                                                <i class="fa-light fa-arrow-right _text-xs _ml-1"></i>
                                            </div>
                                            <div>{{ wish.travelDates.checkout | date:'dd MMM YY' }}</div>
                                        </div>
                                        <div class="_py-2 _px-4" *ngIf="!wish.travelDates">
                                            <span class="_text-primary-1-tint-50">None selected</span>
                                        </div>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="right-aligned-sorted-header">
                                        <span class="_py-2 _px-4">Actions</span>
                                    </th>
                                    <td mat-cell *matCellDef="let wish">
                                        <div class="_flex _justify-end _py-2 _pl-4">
                                            <a target="_blank _text-underline" 
                                                (click)="navigateTo(wish)" 
                                                class="_link _gap-1">
                                                    <i class="fa-sharp fa-light fa-arrow-up-right-from-square"></i>
                                                    View Listing
                                            </a>  
                                            <span class="_mx-2">|</span> 
                                            <a target="_blank _font-underline" 
                                                (click)="removeFromWishlist(wish.wishId)" 
                                                class="_link _gap-1">
                                                    <i class="fa-light fa-trash"></i>
                                                    Remove
                                            </a>                                       
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                                <tr mat-row
                                    *matRowDef="let wish; columns: columnsToDisplay"></tr>

                                <mat-paginator></mat-paginator>
                            </table>
                        </div>
                    </app-overflow-container>
                </ng-template>
            </div>
        </div>
    </div>
</div>
